@if (!isEditMode) {
    <div>
        <div class="flex justify-content-between align-items-center gap-3 mb-3">
            <div class="flex align-items-center gap-2">
                <h2 class="section-title m-0">{{ 'components.settingsForm.tagSection.title' | translate }}</h2>
                <span
                    class="material-symbols-outlined icon-sm text-color-secondary cursor-help"
                    [pTooltip]="'components.settingsForm.tagSection.tooltip.title' | translate"
                    >info</span
                >
            </div>
            <p-button
                [label]="'components.settingsForm.tagSection.addTag' | translate"
                icon="ms ms-add"
                (onClick)="toggleForm()" />
        </div>
        <div class="card">
            <p-treeTable
                #tt
                [value]="tags"
                [columns]="cols"
                filterMode="strict"
                [tableStyle]="{ 'min-width': '50rem', 'table-layout': 'fixed' }">
                <ng-template pTemplate="caption">
                    <p-iconfield>
                        <p-inputicon styleClass="ms ms-search" />
                        <input
                            type="text"
                            pInputText
                            [placeholder]="'results.consolidatedView.actions.searchPlaceholder' | translate"
                            [attr.aria-label]="'common.search' | translate"
                            (input)="tt.filterGlobal($any($event.target).value, 'contains')" />
                    </p-iconfield>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        @for (col of columns; track trackByField($index, col)) {
                            <th
                                [style.width]="getColumnWidth(col.field)"
                                [class.col-actions]="col.field === 'action'"
                                [ttSortableColumn]="col.field === 'name' ? col.field : null">
                                {{ col.header | translate }}
                                @if (col.field === 'name') {
                                    <p-treeTableSortIcon [field]="col.field" />
                                }
                            </th>
                        }
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                    <tr [ttRow]="rowNode">
                        @for (col of columns; track trackByField(i, col); let i = $index) {
                            <td
                                [class.col-actions]="col.field === 'action'"
                                [class.cell-truncate]="col.field !== 'action'">
                                @if (i === 0) {
                                    <p-treeTableToggler [rowNode]="rowNode" />
                                }
                                @if (col.field !== 'action' && col.field !== 'entities') {
                                    {{ rowData[col.field] }}
                                }
                                @if (col.field === 'entities') {
                                    <div class="chip-list">
                                        <!-- The first two entities, then one chip counting the others (listed in its tooltip) -->
                                        @for (
                                            entity of rowData[col.field].slice(0, 2);
                                            track trackByEntityId($index, entity)
                                        ) {
                                            <p-chip [label]="entity.name" [pTooltip]="entity.name" />
                                        }
                                        @if (rowData[col.field].length > 2) {
                                            <p-chip
                                                class="chip-list__more"
                                                [label]="'+' + (rowData[col.field].length - 2)"
                                                [pTooltip]="getEntityTooltipContent(rowData[col.field].slice(2))" />
                                        }
                                    </div>
                                }
                                @if (col.field === 'action') {
                                    <p-button
                                        icon="ms ms-edit"
                                        [text]="true"
                                        [rounded]="true"
                                        size="small"
                                        [ariaLabel]="'components.settingsForm.button.edit' | translate"
                                        [pTooltip]="'components.settingsForm.button.edit' | translate"
                                        (onClick)="toggleForm(rowNode)" />
                                }
                            </td>
                        }
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length">
                            <div class="empty-state empty-state--compact">{{ 'common.noData' | translate }}</div>
                        </td>
                    </tr>
                </ng-template>
            </p-treeTable>
        </div>
    </div>
}

@if (isEditMode) {
    <div>
        <app-edit-tag
            (cancelled)="onCancelEdit()"
            (save)="onSaveEdit($event)"
            [entities]="entities"
            [possibleParentTags]="possibleParentTags"
            [possibleChildTags]="possibleChildTags"
            [organizationId]="organizationId"
            [selectedRowNode]="selectedTag"></app-edit-tag>
    </div>
}
